module.exports = __webpack_public_path__ + "components/resort-guide/item/static/icon-advanced--black-2a6d8ee54861ae3292cb4935e20a8659.svg";